<template>
<header
  class="page-header-mobile page-header-fixed"
  :class="{
    'page-header-mobile--search-active': searchIsActive,
  }"
>
  <div v-if="productsSearchEnabled" class="page-header-mobile__search">
    <Search
      :active.sync="searchIsActive"
      @clear="searchIsActive = false"
    />
  </div>
  <div v-else class="w-10"></div>
  <div class="page-header-mobile__home-link-wrapper">
    <router-link :to="{ name: 'home' }" class="page-header-mobile__home-link">
      <img :src="logo" alt="">
    </router-link>
  </div>
  <div class="page-header-mobile__city-select">
    <HeaderCitySelect
      v-if="displayCitySelect"
      v-on="citySelectProps.listeners"
      v-bind="citySelectProps.props"
    >
      <template #toggle="{ activeCity }">
        <button
          type="button"
          :aria-label="`Город${activeCity && (', ' + activeCity.name) || ''}`"
        >
          <IconMapMarker class="page-header__city-icon"/>
        </button>
      </template>
    </HeaderCitySelect>
  </div>
</header>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from './mixin';

// export const height = '56px';
export default {
  mixins: [mixin],
  components: {
    Search: () => import(/* webpackPreload: true */ '@/components/search/Search'),
    HeaderCitySelect: () => import('./HeaderCitySelect'),
    IconMapMarker: () => import('@/assets/images/icons/icon-map-marker.svg?inline'),
  },
  computed: {
    ...mapGetters({
      logo: 'settings/headerLogo',
      productsSearchEnabled: 'store/productsSearchEnabled',
    }),
  },
}
</script>

<style lang="less">
@import './common';

@r: page-header-mobile;

@side-elements-width: theme('width.12');

.@{r} {
  #page-headers-common.header();
  height: var(--header-height);
  @apply flex bg-sidebar-bg text-sidebar-text px-1;
  > * {
    @transition-duration: 0.3s;
    transition:
      flex-grow @transition-duration,
      flex-basis @transition-duration,
      opacity @transition-duration,
      visibility @transition-duration;
  }
  &__search {
    flex-basis: @side-elements-width;
    .search-component {
      @apply h-full flex items-center;
      .search-component__open-button {
        @apply text-xl w-12 h-full;
      }
      .search-input-wrapper {
        @apply mx-1;
        input {
          @apply text-base;
        }
        .cancel-search-btn {
          @apply text-3xl;
        }
      }
    }
  }
  &__home-link-wrapper {
    @apply flex justify-center flex-grow;
    > img {
      @apply flex-grow;
      object-fit: contain;
    }
  }
  &__home-link {
    @apply flex;
    padding: calc(theme('padding.2') + theme('padding.1') / 4) theme('padding.1');
    > img {
      @apply flex-grow;
      object-fit: contain;
    }
  }
  &__city-select {
    flex-basis: @side-elements-width;
    .page-header-dropdown-label-text {
      @apply hidden;
    }
    .dropdown-modal-toggle {
      @apply h-full flex items-center justify-center;
      svg {
        @apply w-4 fill-current;
      }
    }
  }
  &--search-active {
    > *:not(.@{r}__search) {
      @apply invisible;
      @apply flex-grow-0;
      opacity: 0;
      flex-basis: 0;
      width: 0;
    }
    .@{r}__search {
      @apply flex-grow;
      .search-input-wrapper {
        @apply w-full;
        input {
          @apply border-none;
        }
      }
    }
  }
}
</style>
